export default __webpack_public_path__ + "static/media/image1.1e45d04f.png";